/** @jsxImportSource @emotion/react */
import { Global, css } from "@emotion/react";
import { useMantineTheme } from "@mantine/core";

export function CalendarStyles() {
  const theme = useMantineTheme();

  return (
    <Global
      styles={css`
        /* Calendario general - Mayor especificidad */
        .rbc-calendar {
          font-family: inherit !important;
          font-size: 0.875rem !important;
          background: transparent !important;
        }

        /* Toolbar */
        .rbc-toolbar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
          padding: 8px 0;
        }

        .rbc-toolbar button {
          background: ${theme.colors.blue[6]} !important;
          color: white !important;
          border: none !important;
          border-radius: ${theme.radius.sm} !important;
          padding: 6px 12px !important;
          font-size: ${theme.fontSizes.xs} !important;
          cursor: pointer;
          transition: background 0.2s ease;
        }

        .rbc-toolbar button:hover {
          background: ${theme.colors.blue[5]} !important;
        }

        /* Encabezados (días de la semana) */
        .rbc-header {
          text-align: center !important;
          font-weight: 600 !important;
          font-size: 0.75rem !important;
          padding: 1rem 0.5rem !important;
          background: transparent !important;
          border-bottom: none !important;
          color: #686565ff !important;
          text-transform: uppercase !important;
          letter-spacing: 0.05em !important;
        }
        
        /* Texto del encabezado sin fondo */
        .rbc-header a,
        .rbc-header button {
          background: transparent !important;
          color: inherit !important;
          text-decoration: none !important;
        }

        /* Borde general */
        .rbc-month-view {
          border: 1px solid #dddddd !important;
          border-radius: 14px !important;
          overflow: hidden !important;
          display: flex !important;
          flex-direction: column !important;
          position: relative !important;
          background: hsl(var(--card)) !important;
          overflow-y: auto !important;
          flex: 1 !important;
          scroll-behavior: smooth !important;
        }

        .rbc-time-view .rbc-allday-cell { 
        width: auto
        }

        /* Días */
        .rbc-day-bg {
          border-left: 1px solid hsl(var(--border)) !important;
          border-bottom: 1px solid hsl(var(--border)) !important;
          transition: background 0.2s ease !important;
        }
        
        /* Primera columna de cada fila */
        .rbc-day-bg:first-child {
          border-left: none !important;
        }

        .rbc-day-bg:hover {
          background: hsl(var(--muted) / 0.3) !important;
        }

        .rbc-off-range-bg {
          background: hsl(var(--muted) / 0.2) !important;
        }

        .rbc-today {
          background: hsl(var(--primary) / 0.05) !important;
        }

        /* Número del día */
        .rbc-date-cell {
          text-align: right !important;
        }

        .rbc-now .rbc-button-link {
          color: hsl(var(--primary)) !important;
          font-weight: 700 !important;
          background: transparent !important;
        }


/* Bordes internos de la grilla */
// .rbc-month-view .rbc-day-bg {
//   border-right: 1px solid #f1f5f5 !important;
//   border-bottom: 1px solid #f1f5f5 !important;
// }

// /* Quitar borde derecho en la última columna */
// .rbc-month-view .rbc-row .rbc-day-bg:last-child {
//   border-right: none !important;
// }

// /* Quitar borde inferior en la última fila */
// .rbc-month-row:last-child .rbc-day-bg {
//   border-bottom: none !important;
// }



        .rbc-month-view .rbc-day-bg:hover {
          background: ${theme.primaryColor === "dark"
          ? theme.colors.dark[5]
          : theme.colors.gray[0]} !important;
        }

        .rbc-month-row {
          min-height: 140px !important;
        }

        /* Eventos */
        .rbc-event {
          padding: 0.25rem 0.5rem !important;
          border-radius: 0.375rem !important;
          border: none !important;
          font-size: 0.75rem !important;
          font-weight: 500 !important;
          cursor: pointer !important;
          background: #e5f1fb !important;
          transition: transform 0.2s ease, box-shadow 0.2s ease !important;
          border-left: 4px solid #0074d9 !important;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
        }

        .rbc-day-slot .rbc-event, 
        .rbc-day-slot .rbc-background-event {
          border: none !important;
          border-left: 4px solid #0074d9 !important;
        } 

        .rbc-event:hover {
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15) !important;
        }

        .rbc-event.rbc-selected {
          box-shadow: 0 0 0 2px hsl(var(--ring)) !important;
          background: #e5f1fb !important;
          border-left: 4px solid #0074d9 !important;
          border: none !important;
        }

        .rbc-event-label {
          display: none !important;
        }

        .rbc-event-content {
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
        }

        /* Categorías de eventos */
      .rbc-event.event-work {
        background: hsl(var(--calendar-event-work));
        color: white;
      }

      .rbc-event.event-meeting {
        background: hsl(var(--calendar-event-meeting));
        color: white;
      }

      .rbc-event.event-personal {
        background: hsl(var(--calendar-event-personal));
        color: white;
      }

      .rbc-event.event-other {
        background: hsl(var(--calendar-event-other));
        color: white;
      }

      /* Más eventos (+X más) */
      .rbc-show-more {
        background: transparent;
        color: hsl(var(--primary));
        font-size: 0.75rem;
        font-weight: 600;
        padding: 0.25rem;
        margin: 0;
        border: none;
        cursor: pointer;
        transition: color 0.2s ease;
      }

      .rbc-show-more:hover {
        color: hsl(var(--primary-light));
      }

      /* Overlay para eventos */
      .rbc-overlay {
        background: hsl(var(--popover)) !important;
        border: 1px solid hsl(var(--border)) !important;
        border-radius: var(--radius) !important;
        box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.3) !important;
        padding: 0.5rem !important;
        z-index: 10 !important;
        max-height: 350px !important;
        overflow-y: auto !important;
      }

      .rbc-overlay-header {
        font-weight: 600 !important;
        margin-bottom: 0.5rem !important;
        padding-bottom: 0.5rem !important;
        border-bottom: 1px solid hsl(var(--border)) !important;
      }

        /* Vista semana y día */
        .rbc-time-view {
          border: 1px solid #dddddd !important;
          border-radius: 14px !important;
          background: hsl(var(--card)) !important;
        }

        .rbc-time-header {
          border-bottom: 1px solid hsl(var(--border)) !important;
        }

        .rbc-time-content {
          border-top: 1px solid hsl(var(--border)) !important;
        }

        .rbc-timeslot-group {
          border-bottom: 1px solid hsl(var(--border)) !important;
        }

        .rbc-current-time-indicator {
          background-color: hsl(var(--primary)) !important;
          height: 2px !important;
        }

        /* === Personalización de la vista Agenda === */
        .rbc-agenda-view {
          background: hsl(var(--card)) !important;
          border: 1px solid #ddd !important;
          border-radius: 12px !important;
          overflow: auto !important;
          max-width: 100% !important;
          margin-top: 1rem !important;
        }

        /* Tabla interna */
        .rbc-agenda-table {
          width: 100% !important;
          border-collapse: collapse !important;
          border-radius: 12px !important;
          overflow: hidden !important;
          font-size: 0.875rem !important;
        }

        /* Encabezados */
        .rbc-agenda-view thead th {
          background: #e5f1fb !important;
          color: #0074d9 !important;
          font-weight: 600 !important;
          padding: 0.75rem 1rem !important;
          border-bottom: 1px solid #ddd !important;
          text-transform: uppercase !important;
          font-size: 11px !important;
        }

        /* Filas */
        .rbc-agenda-view tbody tr {
          border-bottom: 1px solid #eee !important;
          transition: background 0.2s ease !important;
        }

        /* Hover */
        .rbc-agenda-view tbody tr:hover {
          background: hsl(var(--muted) / 0.2) !important;
        }

        /* Celdas */
        .rbc-agenda-date-cell,
        .rbc-agenda-time-cell,
        .rbc-agenda-event-cell {
          padding: 0.75rem 1rem !important;
          color: #333 !important;
          font-size: 12px !important;
        }

        /* Evento seleccionado */
        .rbc-agenda-event.rbc-selected {
          background: #e5f1fb !important;
          border-left: 4px solid #0074d9 !important;
        }

        .rbc-slot-selection {
          background-color: #e5f1fb !important;
          border: none !important;
          color: #0074d9 !important;
        }

        /* === Vista de mes: encabezado fijo === */
        .rbc-month-header {
          position: sticky !important;
          top: 0 !important;
          background: white !important;
          z-index: 5 !important;
        }

        .rbc-month-view > .rbc-month-row {
          flex: 1 !important;
          overflow-y: auto !important;
        }

      

      `}
    />
  );
}
